<div class="form-container">
  <h4 class="section-title ">{{ 'FRONT_USER.REQUEST_DETAILS.REQUEST_DETAILS' | translate }}</h4>
</div>
<div class="request-summary">
  <div class="request-summary-details">
    <label>{{ 'FRONT_USER.REQUEST_DETAILS.REQUEST_NUMBER' | translate }}: </label>
    <label>{{baseRequest?.RequestNumber}}</label>
  </div>
  <div class="request-summary-details">
    <label>{{ 'FRONT_USER.REQUEST_DETAILS.SERVICE_NAME' | translate }}: </label>
    <label *ngIf="displayedLang==Languages.English">{{baseRequest?.ServiceNameEN}}</label>
    <label *ngIf="displayedLang==Languages.Arabic">{{baseRequest?.ServiceNameAR}}</label>
  </div>
  <div class="request-summary-details">
    <label *ngIf="!isLongHaulReleaseRequest">{{ 'FRONT_USER.REQUEST_DETAILS.REQUESTOR_EMAIL' | translate }}: </label>
    <label *ngIf="isLongHaulReleaseRequest">{{ 'FRONT_USER.REQUEST_DETAILS.CREATOR' | translate }}: </label>
    <label>{{baseRequest?.CreatedBy}}</label>
  </div>
  <div *ngIf="!isLongHaulReleaseRequest" class="request-summary-details">
    <label>{{ 'FRONT_USER.REQUEST_DETAILS.REQUESTOR_Name' | translate }}: </label>
    <label *ngIf='isAdmin  && ( isAgent || isPortal)'><a href="{{url}}" class="clickable-ele" target="_blank"> {{baseRequest?.RequestorName}}</a></label>

    <label *ngIf='!isAdmin || (isAdmin && isOffline && service == Service.AgentRegisteration )' >{{baseRequest?.RequestorName}}</label>
  </div>
  <!-- <div *ngIf="isLongHaulReleaseRequest" class="request-summary-details">
    <label>{{ 'FRONT_USER.REQUEST_DETAILS.CREATOR_NAME' | translate }}: </label>
    <label> {{longHaulReleaseCreatorName}}</label>
  </div> -->
  <div class="request-summary-details">
    <label>{{ 'FRONT_USER.REQUEST_DETAILS.REQUEST_STATUS' | translate }}: </label>
    <label *ngIf="displayedLang==Languages.English">{{baseRequest?.StatusEN}}</label>
    <label *ngIf="displayedLang==Languages.Arabic">{{baseRequest?.StatusAR}}</label>
  </div>
  <div class="request-summary-details">
    <label>{{ 'FRONT_USER.REQUEST_DETAILS.DATE_CREATED' | translate }}: </label>
    <label>{{baseRequest?.CreationDate| date: 'dd/MM/yyyy H:mm:ss'}} {{'GMT+2'}}</label>
  </div>

  <div class="request-summary-details">
    <label>{{ 'FRONT_USER.REQUEST_DETAILS.ACTION_DATE' | translate }}: </label>
    <label>{{baseRequest?.ModifiedDate| date: 'dd/MM/yyyy H:mm:ss '}} {{'GMT+2'}}</label>
  </div>

</div>
